export function showJetToast(text: string) {
    document.getElementById("myToast").classList.remove("hidden");
    document.getElementById("toast-text").innerText = text;
    setTimeout(function () {
        document.getElementById("myToast").classList.add("hidden");
    }, 3000);
}